/**
 * GDSCardInteractionEventHandler.js
 * Handles all user interactions for Step 3 cards and modals.
 */
export class GDSCardInteractionEventHandler {
    constructor(builder) {
        this.builder = builder;
        this.cardManager = builder.cardManager;
        this.modalManager = builder.modalManager;
        this._boundClickHandler = this._handleClick.bind(this);
        this._boundChangeHandler = this._handleChange.bind(this);
    }

    setupListeners() {
        const container = this.builder.contentContainer;
        if (!container) return;
        // Use event delegation for all interactions within the step
        container.addEventListener('click', this._boundClickHandler);
        container.addEventListener('change', this._boundChangeHandler);
    }

    removeListeners() {
        const container = this.builder.contentContainer;
        if (!container) return;
        container.removeEventListener('click', this._boundClickHandler);
        container.removeEventListener('change', this._boundChangeHandler);
    }

    _handleClick(e) {
        const card = e.target.closest('.product-card');
        const editBtn = e.target.closest('.edit-options-btn');
        const saveBtn = e.target.closest('.modal-save-btn');
        const closeBtn = e.target.closest('.modal-close');
        const backdrop = e.target.closest('.modal-backdrop');

        if (editBtn && card) {
            e.stopPropagation();
            const modal = document.getElementById(editBtn.dataset.modalTarget);
            this.modalManager.openEditModal(modal);
        } else if (card) {
            // Prevent card selection if clicking an interactive element inside it.
            if (e.target.closest('button, a, select, input, .preview-eye-btn')) return;
            this.cardManager.ui.toggleCardSelection(card);
            this.builder.urlManager.updateURLWithNewSnapshotId(true, true);
        } else if (saveBtn) {
            e.stopPropagation();
            const modal = e.target.closest('.product-modal');
            const cardForModal = this.builder.contentContainer.querySelector(`[data-modal-id="${modal.id}"]`);
            this.modalManager.editModal.handleSave(modal, cardForModal, modal._tempSelections);
        } else if (closeBtn || backdrop) {
            e.stopPropagation();
            const modal = e.target.closest('.product-modal');
            this.modalManager.closeEditModal(modal);
        }
    }

    _handleChange(e) {
        const select = e.target.closest('.modal-option-select');
        const checkbox = e.target.closest('input[type="checkbox"]');

        if (select) {
            const modal = select.closest('.product-modal');
            const card = this.builder.contentContainer.querySelector(`[data-modal-id="${modal.id}"]`);
            const field = select.dataset.field;
            const value = select.value;
            this.modalManager.editModal.handleOptionSelection(field, value, modal._tempSelections, modal, card);
        } else if (checkbox) {
            const modal = checkbox.closest('.product-modal');
            const card = this.builder.contentContainer.querySelector(`[data-modal-id="${modal.id}"]`);
            const field = checkbox.closest('[data-field]')?.dataset.field;
            const value = checkbox.checked ? checkbox.dataset.value : (checkbox.dataset.alternateValue || undefined);
             this.modalManager.editModal.handleOptionSelection(field, value, modal._tempSelections, modal, card);
        }
    }
}
